import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

class MapCustomControl implements mapboxgl.IControl {
  public container: HTMLDivElement;

  constructor() {
    this.container = document.createElement('div');
    this.container.className = 'mapboxgl-ctrl';
  }

  onAdd(map: mapboxgl.Map): HTMLElement {
    map.getContainer().appendChild(this.container);
    return this.container;
  }

  onRemove(): void {
    this.container.parentNode.removeChild(this.container);
  }
}

export default MapCustomControl;